import {
  Component,
  forwardRef,
  HostBinding,
  HostListener,
  Input,
  OnInit
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  AbstractControl
} from '@angular/forms';

import { ICustomSelect } from './../../../models/generic';

@Component({
  selector: 'app-c-select-multi',
  templateUrl: './c-select-multi.component.html',
  styleUrls: ['./c-select-multi.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CSelectMultiComponent),
      multi: true
    }
  ]
})
export class CSelectMultiComponent implements OnInit, ControlValueAccessor {
  @Input() selectAndClose = false;
  @Input() optionsList: ICustomSelect[] = [];
  @Input() value: string[] = [];
  @Input() placeholder: string = 'Placeholder';
  @Input() disabled = false;
  @Input() multi = false;

  @Input() maxHeight = 15;
  @Input() formValidator!: AbstractControl;

  classUuID: string = 'abc';
  valueDescription: string = '';
  expanded = false;

  ngOnInit(): void {
    this.getInitialValue();
  }

  showCheckboxes() {
    if (this.disabled) return;
    this.expanded = !this.expanded;

    this.getInitialValue();
  }

  writeValue(value: string[]): void {
    if (!value?.length) value = [];

    this.value = value;

    this.getInitialValue();
  }

  getInitialValue() {
    if (this.multi) {
      this.valueDescription = `${this.value.length} Selecionados`;
    } else {
      this.valueDescription =
        this.optionsList.find((op) => op.id === this.value[0])?.name || '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange = (value: string[]) => {};
  onTouched = () => {};

  selectOptions(option: ICustomSelect) {
    if (this.multi) {
      if (this.value.length && this.value.some((o) => o === option.id)) {
        this.value = this.value.filter((v) => v !== option.id);
      } else {
        this.value.push(option.id);
      }
      this.valueDescription = `${this.value.length} Selecionados`;
    } else {
      this.value = [option.id];
      this.valueDescription = option.name;
      this.showCheckboxes();
    }

    this.onChange(this.value);

    if (this.selectAndClose) this.showCheckboxes();
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any): void {
    if (!event?.target?.className.includes(this.classUuID))
      this.expanded = false;
  }
}
